<template lang="pug">
v-container
  v-row.mb-5.justify-space-around
    v-col(:cols="form.document ? '' : '5'" v-if="form.is_offer")
      v-card(flat).text-center.align-self-center
        v-icon(color="secondary" size=100) mdi-credit-card-outline
        .grey--text Процент авансирования
        h1.mt-4() {{ form.prepayment_percent }}%
        v-slider.mt-2(
          v-model="form.prepayment_percent"
          min="1"
          max='100'
          hide-details
        )
    v-col(cols="auto" v-if="form.document || form.preview_document")
      v-card.d-flex.align-center.justify-space-around.relative.flex-column.mx-4.px-1(
        height='100%'
        flat
      )
        v-icon(
          color="secondary"
          size=100
        ) {{ !form.id || edit ? 'mdi-file-upload-outline' : 'mdi-file-document-outline'}}
        file-input.mt-4(
          v-if="!form.is_offer && form.document"
          v-model="form.document.file_name"
          :url.sync="form.document.url"
          :originalName="form.document.original_name"
          label="Нажмите для выбора договора"
          vid="file"
          name="Файл"
        )
        v-btn.mt-4(
          v-if="form.is_offer"
          color="success"
          large
          @click="openPreviewDocument"
        ).mb-2 Предпросмотр договора
  v-window(v-model="window")
    v-window-item.pb-1
        v-row.ma-0.align-center.mb-2
          h4 {{ payload.id ? 'Редактирование скидки' : 'Создание скидки'}}
          v-spacer
          v-btn(icon @click="close" color="error")
            v-icon mdi-close
        v-row.ma-0.align-center.mb-3.grey.lighten-3.rounded-xl.px-8.py-2
          span Процент скидки
          v-slider.mx-6(
            v-model="payload.percent"
            min="0"
            max='100'
            step="5"
            thumb-label
            hide-details
          )
          .text-h5: strong {{ payload.percent }}%
        v-row.ma-0
          v-text-field.mr-2(
            v-model="payload.min_users"
            dense
            rounded filled
            label="минимальное количество участников"
          )
          v-text-field(
            v-model="payload.max_users"
            dense
            rounded filled
            label="максимальное количество участников"
          )
        v-row.ma-0
          v-spacer
          v-btn(
            color="success" @click="handleSaveMethod(i)" :loading="createLoading"
          ) {{ payload.id ? 'Сохранить' : 'Добавить скидку'}}
    v-window-item
      v-sheet.mb-2(v-if="form.id")
        h4 Скидки
        v-skeleton-loader(
          v-if="loading"
          type="list-item@2"
        )
        v-slide-group(v-else)
          v-slide-item(
            v-for="(i, idx) in discounts" show-arrows
            :key="idx"
          ).my-3
            v-hover(v-slot="{ hover }")
              v-card.mr-2.sdo-card.lighten-1(
                :color="i.is_active ? 'success' : 'grey'"
              )
                v-card-text.white--text.text-center.relative
                  .text-h4.white--text.pb-0: strong {{ i.percent }}%
                  span  {{i.min_users}} - {{i.max_users}} участников
                  v-overlay(:value="hover" absolute).discount__overlay
                    v-btn.mr-1.mt-1(
                      fab
                      x-small
                      style="position: absolute; top: 0; right: 0;"
                      color="error"
                      @click="deleteDiscount(i)"
                    )
                      v-icon mdi-delete
                    v-btn(color="primary" fab @click="openEditWindow(i)")
                      v-icon mdi-pencil
                v-card-actions.pa-0
                  v-btn.discount__btn(
                    @click.stop="handleActivateDiscount(i)"
                    block
                    small
                    :color="!i.is_active ? 'success lighten-1' : 'error darken-1'"
                  ) {{i.is_active ? 'Деактивировать' : 'Активировать'}}
          v-slide-item.my-3
            v-card.sdo-card.lighten-1(
              @click="openEditWindow"
            ).justify-center.px-4.text-center.align-center
              v-icon(size="52" color="success") mdi-plus
              span.grey--text добавить скидку
      v-sheet(color="grey lighten-4" v-if="form.is_offer").pa-5
        .grey--text.mb-2.
          Окончательный расчет по Договору осуществляется
          Заказчиком не позднее указанного числа дней до завершения обучения.
        c-input.my-2.pa-2(
          v-model="form.day_before_course_end" placeholder="Заполните количество дней"
        )
        shapka-field(v-model="form.header" )
        //- c-c-input(v-model="form.header" placeholder="Заполните шапку договора")
      v-sheet.d-flex.flex-column(color="grey lighten-4" v-else).pa-5
        .grey--text.mb-2.
          Здесь укажите контактные данные специалиста,
          с которым необходимо связаться для заключения договора
        c-input.my-1(v-model="form.contact_data" placeholder="Заполните контактные данные")
      v-row.ma-0.mt-4
        v-btn(
          color="success"
          @click="successCallback(form)"
          large
          block
          :disabled="form.document && !(form.document.file_name || form.document.original_name)"
        ) Сохранить

</template>

<script>
import CInput from '@/components/Constructor/CInput.vue';
import FileInput from '@/components/InputFields/FileInput.vue';
import FileUpload from '@/components/InputFields/FileUpload.vue';
import PreviewContract from './PreviewContract.vue';
import shapkaField from './shapkaField.vue';

export default {
  name: 'ModulePreview',
  components: {
    FileUpload,
    FileInput,
    CInput,
    shapkaField,
    PreviewContract,
  },
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
    successCallback: { type: Function, required: true },
  },
  data() {
    return {
      showLicense: false,
      placeholder: 'Осуществляющее образовательную деятельность на основании Лицензии №100001, выданной Департаментом образования города Москвы',
      window: 1,
      form: { ...this.moduleItem },
      togglePayment: false,
      agreementText: null,
      edit: false,
      discounts: [],
      loading: true,
      createLoading: false,
      payload: {
        is_active: false,
      },
    };
  },
  watch: {
    showLicense(val) {
      if (!val) this.form.license_info = null;
      else this.form.license_info = this.placeholder;
    },
  },
  created() {
    this.getDescounts();
    this.showLicense = !!this.form.license_info;
  },
  methods: {
    openPreviewDocument() {
      this.$modals.show('generic-controller', {
        component: PreviewContract,
        title: 'Предпросмотр',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          previewDocument: this.form.preview_document,
        },
      });
    },
    async handleActivateDiscount(discount) {
      const payload = {
        ...discount,
        is_active: !discount.is_active,
      };
      const { data } = await this.$api.contracts.updateDiscounts(discount.id, payload);
      if (data) {
        discount.is_active = !discount.is_active;
        this.$toasted.success('Успешно');
      }
    },
    close() {
      this.payload = { is_active: false };
      this.window = 1;
    },
    openEditWindow(item) {
      this.payload = { ...item };
      this.window = 0;
    },
    async getDescounts() {
      const params = {
        'search[typical_contract_id]': this.form.id,
      };
      const { data } = await this.$api.contracts.getDiscounts({ params });
      this.discounts = data.data;
      this.loading = false;
    },
    async deleteDiscount({ id }) {
      const { data } = await this.$api.contracts.deleteDiscount(id);
      if (data) {
        this.$toasted.success('Успешно');
      }
    },
    handleSaveMethod() {
      if (this.payload.id) this.updateDiscount();
      else this.createDiscount();
    },
    async createDiscount() {
      this.createLoading = true;
      const payload = {
        ...this.payload,
        typical_contract_id: this.form.id,
      };
      await this.$api.contracts.createDiscount(payload);
      this.createLoading = false;
      this.window = 1;
    },
    async updateDiscount() {
      this.createLoading = true;
      const payload = {
        ...this.payload,
        typical_contract_id: this.form.id,
      };
      const { data } = await this.$api.contracts.updateDiscounts(this.payload.id, payload);
      if (data) {
        this.$toasted.success('Успешно');
      }
      this.createLoading = false;
      this.window = 1;
    },
  },
};
</script>

<style scoped lang="scss">
.discount__btn {
  border-radius: 0;
}
.discount__overlay {
  ::v-deep .v-overlay__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
}

.contract-file-actions {
  position: absolute;
  top: 0;
  left: -25px;
}
</style>
